module.exports = __webpack_public_path__ + "img/logo-lokroi.ac09a527.svg";